/**
 *
 * OnClickOutside
 *
 */

import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { useOnClickOutside } from 'hooks'

const OnClickOutside = (props) => {
	const component = useRef()
	useOnClickOutside(component, props.handleClickOutside)

	return <span ref={component}>{props.children}</span>
}

OnClickOutside.propTypes = {
	handleClickOutside: PropTypes.func.isRequired,
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

export default OnClickOutside
